import React, { useEffect } from "react";
import "./index.css";
import Home from "./routes/Home";
import About from "./routes/About";
import Project from "./routes/Project";
import WebDesign from "./routes/WebDesign";
import WebDevelopment from "./routes/WebDevelopment";
import SystemDevelopment from "./routes/SystemDevelopment";
import Contact from "./routes/Contact";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";

/*function disableRightClick(event) {
  event.preventDefault();
}*/

function App() {
  const location = useLocation();
  /*useEffect(() => {
    window.addEventListener("contextmenu", disableRightClick);

    return () => {
      window.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);*/

  const pageTransition = {
    initial: {
      opacity: 0,
      y: 20,
      skewY: 2,
    },
    animate: {
      opacity: 1,
      y: 0,
      skewY: 0,
      transition: {
        duration: 0.65, // slowed down
        ease: [0.4, 0, 0.2, 1],
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      skewY: -1,
      transition: {
        duration: 0.45, // slightly slower exit too
        ease: 'easeInOut',
      },
    },
  };


  return (
    <>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <Home />
              </motion.div>
            }
          />
          <Route
            path="/project"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <Project />
              </motion.div>
            }
          />
          <Route
            path="/project/web-design"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <WebDesign />
              </motion.div>
            }
          />
          <Route
            path="/project/web-development"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <WebDevelopment />
              </motion.div>
            }
          />
          <Route
            path="/project/system-development"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <SystemDevelopment />
              </motion.div>
            }
          />
          <Route
            path="/contact"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <Contact />
              </motion.div>
            }
          />
          <Route
            path="/about"
            element={
              <motion.div
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
              >
                <About />
              </motion.div>
            }
          />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
